import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  validateWrongProductCondition,
  wrongProductFromModel,
  type WrongProductState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const WRONG_PRODUCT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<WrongProductState>>,
): ConditionType<WrongProductState, Condition.WrongProduct> => ({
  name: "Wrong product",
  description(state) {
    return "Return is for wrong product";
  },
  Details(props: ConditionTypeDetailsProps<WrongProductState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return wrongProductFromModel(model);
  },
  toModel(state) {
    return { type: Condition.WRONG_PRODUCT };
  },
  valid(state) {
    return validateWrongProductCondition(state).valid;
  },
});

export { type WrongProductState } from "@redotech/redo-model/return-flow/condition-validate";
